import { ValueSource } from "constants/ruleBooks";
import { getRelationPath } from "containers/Settings/RuleBooks/Schema/schema";
import startCase from "lodash/startCase";

interface RuleValueDataSource {
  criteria_output_index?: number;
  key?: string;
  source?: ValueInObj<typeof ValueSource>;
  value?: boolean | number | string;
}

const RuleValueFieldDisplayName: Record<string, string> = {
  total_hd_exc_progeny: "Total Head Excluding Progeny",
};

const formatFieldName = (value?: boolean | number | string) => {
  if (typeof value !== "string") {
    return `${value ?? ""}`;
  }
  return (
    RuleValueFieldDisplayName[value] ||
    startCase(getRelationPath(value).replace(/[.:]/g, " "))
  );
};

const formatField = ({ key, value }: RuleValueDataSource) => {
  const field = formatFieldName(value);
  return key ? `${field} → ${formatFieldName(key)}` : field;
};

export const formatRuleValueDataSource = (
  dataSource?: RuleValueDataSource,
): string => {
  if (!dataSource?.source) {
    return "";
  }

  const criteriaNumber =
    dataSource.criteria_output_index === undefined
      ? null
      : dataSource.criteria_output_index + 1;

  switch (dataSource.source) {
    case ValueSource.CONSTANT:
      return `${dataSource.value ?? ""}`;
    case ValueSource.FIELD:
    case ValueSource.DEPENDENCY_VALUE:
    case ValueSource.RULESET_FIELD:
      return formatField(dataSource);
    case ValueSource.SUM:
      return `Sum of ${formatField(dataSource)}${
        criteriaNumber === null ? "" : ` (Criteria ${criteriaNumber})`
      }`;
    case ValueSource.COUNT:
      return `Count${
        criteriaNumber === null ? "" : ` (Criteria ${criteriaNumber})`
      }`;
    default:
      return `${dataSource.value ?? dataSource.source}`;
  }
};

const RuleValueOptionDisplayName: Record<string, string> = {
  LAST_05_UP: "Last 5 Up",
};

export const formatRuleValueOption = (value?: string): string =>
  value
    ? RuleValueOptionDisplayName[value] || startCase(value.toLowerCase())
    : "";
